var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendBroadcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    style: {
      enableBackground: "new 0 0 27 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F04422;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,16.6c-0.3,0-0.6,0.3-0.6,0.6v2.9c0,0.7-0.5,1.2-1.2,1.2h-11c-0.7,0-1.2-0.5-1.2-1.2V9.4c0-0.7,0.5-1.2,1.2-1.2h4.3 c0.3,0,0.6-0.3,0.6-0.6C9.8,7.3,9.6,7,9.2,7H4.9C3.6,7,2.5,8.1,2.5,9.4v10.7c0,1.3,1.1,2.4,2.4,2.4l11,0c1.4,0,2.4-1.1,2.4-2.4v-3 C18.4,16.8,18.1,16.6,17.8,16.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,8.4l-6.1-4.7c-0.3-0.2-0.6-0.2-0.9,0.1c-0.2,0.3-0.2,0.6,0.1,0.8l4.8,3.7h-5.6c-3.7,0-6.7,2.9-6.7,6.5V16 c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6v-1.2c0-3,2.5-5.4,5.5-5.4h5.6l-4.8,3.7c-0.3,0.2-0.3,0.6-0.1,0.8 c0.1,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3,0,0.4-0.1l6.1-4.8c0.1-0.1,0.2-0.3,0.2-0.5S24.4,8.5,24.3,8.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBroadcast);
export default __webpack_public_path__ + "static/media/sendBroadcast.4621ae7499756650f08c01178638decb.svg";
export { ForwardRef as ReactComponent };